// collectionMetadataApi.ts
import { apiPaths, vivaApi } from '@services';
import { transformCollectionMetadata } from '../metadataMappers';
import {
    BackendCollectionMetadata,
    CollectionMetadata,
    GetCollectionMetadataArgs,
} from '../metadataTypes';

const extendedApi = vivaApi.injectEndpoints({
    endpoints: (builder) => ({
        getCollectionMetadata: builder.query<
            CollectionMetadata,
            GetCollectionMetadataArgs
        >({
            query: ({ title, proscopeId }) => ({
                method: 'GET',
                url: apiPaths.metadata.getCollectionMetadata(title, proscopeId),
            }),
            transformResponse: (
                response: BackendCollectionMetadata[],
                meta,
                arg,
            ) => {
                const backendMetadata: BackendCollectionMetadata =
                    response?.[0] || {};
                return transformCollectionMetadata(backendMetadata, meta, arg);
            },
            providesTags: () => [{ type: 'CollectionMetadata', id: 'LIST' }],
        }),
    }),
});

export const { useGetCollectionMetadataQuery } = extendedApi;

export default extendedApi.endpoints;
